import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'floorOrdinal'
})
export class FloorOrdinalPipe implements PipeTransform {

    transform(value: string): string {

        if (value === null || value === undefined || value === '') {
            return '-';
        }   
        // // Ground floor cases
        // if (value === 'G') {
        //     return 'Ground Floor';
        // }

        const suffixes = ["th", "st", "nd", "rd"];
        const v = Number(value) % 100;

        return value +
            (suffixes[(v - 20) % 10] ||
                suffixes[v] ||
                suffixes[0]);
    }

}